module.exports = require("jwt-decode");


//////////////////
// WEBPACK FOOTER
// external "jwt-decode"
// module id = jwt-decode
// module chunks = 3